<script>
import {PaymentGateway} from "@/shared/PaymentGateway";
import GateWays from "@/shared/GateWays";
import Links from "@/shared/constants/Links";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import XButton from "@ui/widgets/XButton.vue";
import MessageBox from "@ui/components/MessageBox.vue";
import LoadingDialog from "@ui/components/LoadingDialog.vue";

export default {
  name: "ProgressStatus",
  components: {LoadingDialog, MessageBox, XButton},
  props: ['user'],
  data: () => ({
    paymentConfig: null,
    paymentGateway: null,
    feePayment: null,
    nextStatus: null,
    currentStatus: null,
    loading: false,
    message: '',
    messageShow: false,
    messageType: ''
  }),

  watch: {
    user: function(val){
      if(val){
        this.getNextForStudent();
        this.getPendingPending()
      }
    },

    nextStatus: function(val){
      if(val && val.requirePayment){
        this.mountGateway();
      }
    }
  },

  computed: {
    hasNext: function(){
      return this.nextStatus != null &&
        (!this.user?.information?.currentAcademicStatus ||
          (this.user?.information?.currentAcademicStatus &&
            this.user?.information?.currentAcademicStatus.id !== this.nextStatus.id
          )
        );
    },

    requiredPayment: function(){
      return this.hasNext && this.nextStatus.requirePayment;
    }
  },

  methods: {
    getNextForStudent(){
      this.loading = true
      Api.studentProgressStatus.nextStatusForStudent(this.user.userId)
        .then(res => {
          this.nextStatus = res.data
        }).catch(err => {
          // ErrorResolver.checkErrors(this, err)
        })
        .finally(() => this.loading = false)
    },

    getCurrentForStudent(){
      this.loading = true
      Api.studentProgressStatus.currentStatusForStudent(this.user.userId)
        .then(res => {
          this.currentStatus = res.data
        }).catch(err => {
          // ErrorResolver.checkErrors(this, err)
        })
        .finally(() => this.loading = false)
    },

    getPendingPending(){
      this.loading = true
      Api.studentProgressStatus.getpendingpayments(this.user.userId)
        .then(res => {
          this.feePayment = res.data
        }).catch(err => {
          // ErrorResolver.checkErrors(this, err)
        })
        .finally(() => this.loading = false)
    },

    initializePayment(){
      if(!this.requiredPayment)
        return

      this.loading = true
      Api.studentProgressStatus.initializePayment(this.user.userId, this.nextStatus.id)
        .then(res => {
          this.feePayment = res.data
          this.message = 'Payment initialized'
          this.messageType = 'success'
          this.messageShow = true
        }).catch(err => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    },

    downloadInvoice(){
      this.loading = true;
      Api.studentProgressStatus.invoice(this.feePayment.transactionId)
        .then(res => {
          let fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          let fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'invoice.pdf');
          document.body.appendChild(fileLink);

          fileLink.click();
          fileLink.remove();
        }).catch(err => ErrorResolver.checkErrors(this, err)).finally(() => this.loading = false)
    },

    makePayment(){
      if (this.feePayment != null) {
        if (this.paymentConfig.inline) {
          this.paymentGateway.makePayment({
            email: this.getUser.email,
            amount: this.feePayment.invoiceAmount,
            currency: 'NGN',
            invoice: this.feePayment.transactionId,
            paymentId: this.feePayment.id
          }, (data) => {
            window.location.reload()
          }, (invoice) => {
            // process
            // this.loading = true
            Api.payment.processInline(invoice)
              .then(() => {
                window.location.href = "/student#/"
              }).catch(err => {
              ErrorResolver.checkErrors(this, err)
              this.loading = false
            }).finally(() => this.loading = false)
          })
        } else {
          // payment should not be done inline
          // open window for payment
          this.loading = true
          window.location.href = this.feePayment.paymentLink
        }
      }
    },

    mountGateway(){
      this.paymentGateway = new PaymentGateway(GateWays.PAYSTACK, this, Links.payments.processInlinePayment)
      if (this.paymentGateway != null) {
        // set config
        this.paymentConfig = this.nextStatus.paymentPlatform
        // if inline, initialize
        if (this.paymentConfig.inline)
          this.paymentGateway.initializeGateway(this.paymentConfig.data)
      } else {
        this.message = 'No payment settings found'
        this.messageType = 'error'
        this.messageShow = true
      }
    }
  },

  created() {
    if(this.user){
      this.getNextForStudent()
      this.getPendingPending()
      this.getCurrentForStudent()
    }
  },

  mounted() {
  }
}
</script>

<template>
  <div>
    <div class="success--text font-weight-bold mt-2">{{currentStatus && currentStatus?.studentProgressStatus?.title || "Student"}}</div>
    <div>Date</div>
    <div class="success--text font-weight-bold mt-2">{{currentStatus && currentStatus?.dateString || "None"}}</div>
  <!-- if next -->
    <template v-if="hasNext">
      <v-sheet outlined rounded class="mt-2 d-flex flex-column pa-4 mx-md-0 mb-2" style="border-radius: 4px; ">
        <div class="font-weight-bold">Next status: {{nextStatus?.title?.toUpperCase() || "None"}}</div>
        <div v-if="requiredPayment" class="mt-4">
          <v-alert type="info" outlined>Payment required</v-alert>
          <x-button width="100%" v-if="feePayment == null" color="primary" :disabled="loading" @click="initializePayment">
            Generate invoice
          </x-button>
          <div v-else>
            <x-button width="100%" color="info" :disabled="loading" @click="downloadInvoice">
              Download invoice
            </x-button>
            <x-button width="100%" color="primary" class="mt-2" :disabled="loading" @click="makePayment">
              Make payment
            </x-button>
          </div>
        </div>
      </v-sheet>
    </template>

    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>

<style scoped>

</style>
